import { z } from '../zod.js';
import { queryInt } from './query.js';
/**
 * Every list response (1.0b conventions): `{items, next}`, `next` being the cursor of the next
 * page, or null on the last page and always on a bounded list. `max`, where given, is a bounded
 * list's bound on `items` (CS r5b: `sessions.sources.list`, `sessions.reveals.list`).
 */
export function listOf(item, max) {
    const items = max === undefined ? z.array(item) : z.array(item).max(max);
    return z.strictObject({ items, next: z.string().min(1).nullable() });
}
/** The opaque cursor of a paged list: the `next` of the page before. */
export const Cursor = z.string().min(1).max(500);
/**
 * `?cursor=&limit=` of a list that can grow without bound (revisions, trash, the Unlinked tab and
 * the like): `limit` from 1 to 200, default 50 (1.0b conventions, "Lists").
 */
export const PageQueryV1 = z.strictObject({
    cursor: Cursor.optional(),
    limit: queryInt(1, 200).default(50),
});
//# sourceMappingURL=list.js.map